import SidebarMenu from './components/SidebarMenu.vue'

export default {
  install(Vue) {
    Vue.component('SidebarMenu', SidebarMenu)
  },
}

export { SidebarMenu }
